import React from 'react';
import { motion } from 'framer-motion';
import { Target, ShieldAlert, Dumbbell, Trophy } from 'lucide-react';
const disciplines = [{
  icon: Target,
  title: 'Fundamentals & Pad Work',
  description: 'Master the mechanics of punches, kicks, knees, and elbows. Heavy emphasis on balance, footwork, and generating devastating power through proper technique.'
}, {
  icon: ShieldAlert,
  title: 'Clinch & Sparring',
  description: 'Live rounds to test your skills. Learn to control the inside game with authentic Thai clinch work, sweeps, and defensive framing against active resistance.'
}, {
  icon: Dumbbell,
  title: 'Fight Conditioning',
  description: 'Build the gas tank required for 5 rounds. High-intensity interval training, heavy bag burnout rounds, and sport-specific strength protocols.'
}, {
  icon: Trophy,
  title: 'Fight Camp Prep',
  description: 'Invitation-only sessions for active competitors. Structured 8-week camps focusing on game planning, weight cutting guidance, and hard sparring.'
}];
export function Training() {
  return <section id="training" className="py-24 bg-zinc-950 relative" data-id="element-150">
      <div className="container mx-auto px-6" data-id="element-151">
        <div className="mb-16 md:mb-24" data-id="element-152">
          <h2 className="font-display text-5xl md:text-7xl text-white uppercase mb-4" data-id="element-153">
            The <span className="text-red-600" data-id="element-154">Curriculum</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl" data-id="element-155">
            We train the authentic way. Every class is structured to build real
            fighting capability, whether you're stepping into the ring or just
            training like you are.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-156">
          {disciplines.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-zinc-900 border border-zinc-800 p-8 md:p-10 hover:border-red-600/50 transition-colors group" data-id="element-157">
              <div className="w-14 h-14 bg-zinc-950 border border-zinc-800 flex items-center justify-center mb-6 text-red-600 group-hover:bg-red-600 group-hover:text-white transition-colors" data-id="element-158">
                <item.icon size={28} data-id="element-159" />
              </div>
              <h3 className="font-display text-3xl text-white uppercase tracking-wide mb-4" data-id="element-160">
                {item.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-161">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}